const getPrintPicto = pictoName => `<i class="header__btn__icon axa-icons ${pictoName}" aria-hidden="true"></i>`;

export const connectedBtn = (path, ressource, picto = '') => {
    if(path && ressource) {
        return `<a class="header__btn"
                    href="${path}">
                    ${picto && getPrintPicto(picto)}
                    <span>${ressource}</span>
                </a>`;
    }

    return '';
};
